import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import { SpinnerButton } from 'common/SpinnerButton';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { ListItem } from './ListItem';
import { AuthContext } from 'contexts/AuthContext';
import { updateUser } from "utils/api";
import { EditUserRoleModal } from "../Modals/EditUserRoleModal";

export const List = ({ users, isLoading, refreshUsers }) => {
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { handleError } = useContext(AuthContext);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null);
    const [filter, setFilter] = useState('all');
    const [filteredUsers, setFilteredUsers] = useState([]);

    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

    const handleEditUserRole = async (id, isAdmin) => {
        try {
            await updateUser(id, isAdmin);
            addFlashMessage('success', 'User role successfully changed');
            refreshUsers();
            toggleEditModal();
            setUserToEdit(null);
        } catch (err) {
            handleError(err);
        }
    };

    useEffect(() => {
        userToEdit && setIsEditModalOpen(true);
    }, [userToEdit]);

    useEffect(() => {
        const usersArr = [...users];
        const filteredArr = usersArr.filter((user) => filter === 'all' ? usersArr : user.roles.includes(filter));
        setFilteredUsers(filteredArr);
    }, [filter, users]);

    return (
        <div className="list publication-list">
            {isLoading ?
                <SpinnerButton/>
                :
                <div>
                    {filteredUsers?.length < 1 ?
                        <div>
                            No results found
                        </div>
                        :
                        <>
                            <div className="list__utility-row list__utility-row--desktop">
                                <div className="flex items-center">
                                    <label className='mr-3 font-medium'>Filter By Role:</label>
                                    <select
                                        onChange={(e) => setFilter(e.target.value)}
                                        value={filter}
                                        style={{
                                            color: '#000',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '3px 5px',
                                        }}>
                                        <option value="all">All</option>
                                        <option value="ROLE_ADMIN">Admin</option>
                                        <option value="ROLE_USER">User</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <Table className="responsive-table">
                                    <tbody>
                                    <tr className="responsive-table header-row">
                                        <th>Email</th>
                                        <th>Roles</th>
                                        <th>Created At</th>
                                        <th style={{ width: '150px' }}>Actions</th>
                                    </tr>

                                    {filteredUsers.map((user) => (
                                        <ListItem
                                            key={user.id}
                                            user={user}
                                            setUserToEdit={setUserToEdit}
                                        />
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>
                    }
                </div>

            }

            {userToEdit && <EditUserRoleModal isOpen={isEditModalOpen} toggle={toggleEditModal}
                                              handleEditUserRole={handleEditUserRole} user={userToEdit}/>}
        </div>
    );
};
